import { render, staticRenderFns } from "./UnitView.vue?vue&type=template&id=569c610c&scoped=true&"
import script from "./UnitView.vue?vue&type=script&lang=js&"
export * from "./UnitView.vue?vue&type=script&lang=js&"
import style0 from "./UnitView.vue?vue&type=style&index=0&id=569c610c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569c610c",
  null
  
)

export default component.exports